<div class="calendar-div">
    <p-calendar [disabled]="editable == false" appendTo="body" [(ngModel)]="dateValue" dateFormat="dd-MM" [showIcon]="true" inputId="dateformat" (onSelect)="onSelect()" [defaultDate]="highlightDate"></p-calendar>
</div>